export default "<div class=\"elevator\">\n  <i class=\"fas fa-chevron-up\"></i>\n</div>\n"